var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('headbox'),_c('costoptimizat'),_c('footbox')],1)}
var staticRenderFns = []

export { render, staticRenderFns }